import { MatchRepository } from "../repositories/MatchRepository";

export class DeleteLike {
	constructor(private repository: MatchRepository) {}
	execute(match_id: string): Promise<void> {
		return this.repository.deleteLike(match_id);
	}
}
